export default "__VITE_ASSET__BvzJ2Hbh__"